var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newdetail_wrap"},[_c('div',{staticClass:"red_top_bg"},[_c('div',{staticClass:"back_left",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")]),_c('div',{staticClass:"big_tit"},[_vm._v("集团公告")])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctn"},[_c('img',{attrs:{"src":require("../images/new/33.jpg"),"width":"100%"}})])
}]

export { render, staticRenderFns }